import { showGlobalModal } from "./showGlobalModal";

export const getErrorMessage = (error: unknown): string => {
    if (error == null) {
        return "Что-то пошло не так";
    }

    if (typeof error === "string") {
        return error;
    }

    if (error instanceof Error) {
        return error.message || "Что-то пошло не так";
    }

    if (typeof error === "object" && "message" in error) {
        const message = (error as { message?: unknown }).message;

        if (typeof message === "string") {
            return message;
        }
    }

    return "Что-то пошло не так";
};

export const showGlobalErrorModal = (error: unknown) => {
    showGlobalModal({
        message: getErrorMessage(error),
    });
};
